import React from 'react';

import SubHeader from '../../common/subHeader';
import Divider from '../../common/divider';
import ATable from '../../common/table';
import Constants from '../../../configurations/constants';
import URLS from '../../../configurations/urls';

const columns = [
    {
        header: "Domain",
        accessor: "domain",
        width : 150
    },

    {
        header: "File",
        accessor: "batchFile",
        width : 300
    },

    {
        header: "Status",
        accessor: "status"
    },

    {
        header: "Records",
        accessor: "recordCount"
    },

    {
        header: "Processed",
        accessor: "processedCount"
    },

    {
        header: "Errors",
        accessor: "errorCount"
    },

    {
        header: "Created By",
        accessor: "createdBy"
    },
    {
        header: "Created On",
        accessor: "createdOn"
    },
    {
        header: "Error File",
        accessor: "errorFile",
        render: (row) => {
            return (
                <div>
                    {row.row.status === Constants.BATCH_STATUS_COMPLETED && row.row.errorCount &&
                        <a target="_blank" href={`${URLS.ARBITER_BASE_PATH}${URLS.ARBITER_API_BASE_PATH}${URLS.ARBITER_API_DISPUTES}${URLS.ARBITER_API_DOWNLOAD_ERROR_FILE}/${row.row.batchFile}`} style={{ whiteSpace: "normal" }}>
                            Download
                    </a>
                    }
                </div>
            )
        }
    },

];

const BulkDisputeTable = (props) => {
    let disputesBatches = props.disputesBatches || [];
    return (
        <div>
            <Divider />
            <SubHeader title="Batches" />
            <Divider />
            {
                <ATable
                    className="-striped -highlight"
                    tableData={disputesBatches}
                    columns={columns}
                    defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}
                    loading={props.loading}
                    onRowClick={props.onRowClick}
                    onChange={props.onTableChange || null}
                    manual
                    {...props}
                />

            }

        </div>
    );
};
export default BulkDisputeTable;



// WEBPACK FOOTER //
// ./src/components/disputeMgmt/bulkDisputes/bulkDisputesTable.js